<div class="content-shadow">
  <div class="header">
    Реєстри
  </div>
  <mat-tab-group
          class="tab-group"
          (selectedIndexChange)="onChangeTabIndex($event)"
          [(selectedIndex)]="selectedIndex"
  >
    <mat-tab label="Для посилок по Україні">
      <app-registers-view [showSectionTitle]="false"></app-registers-view>
    </mat-tab>
    <mat-tab label="Для міжнародних посилок">
      <app-int-registers-view *ngIf="isInternationalTabActivated"></app-int-registers-view>
    </mat-tab>
  </mat-tab-group>
</div>
